// extracted by mini-css-extract-plugin
module.exports = {"qrcodeModal":"QrcodeModal_qrcodeModal___jSpl"};